import { LitElement, html, css } from 'lit';

export class GameStatusLit extends LitElement {
  static styles = css`
    :host {
      display: block;
      padding: 8px 12px;
      background: var(--card, #161614);
      border: 1px solid var(--border, #3f3f3c);
      border-radius: 2px;
      color: var(--accent, #65a30d);
      font-family: var(--font-mono, monospace);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    }
    .status-line {
      margin-bottom: 2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .blink {
      animation: blink 1s step-end infinite;
      color: var(--primary, #92400e);
    }
    @keyframes blink {
      0%, 100% { opacity: 1; }
      50% { opacity: 0; }
    }
  `;

  static properties = {
    status: { type: String },
    zone: { type: String },
  };

  declare status: string;
  declare zone: string;

  constructor() {
    super();
    this.status = 'ONLINE';
    this.zone = 'НИЗИНА';
  }

  render() {
    return html`
      <div class="status-line">> CONNECTION: ${this.status}</div>
      <div class="status-line">> SECTOR: ${this.zone}</div>
      <div class="status-line">> SCANNING... <span class="blink">|</span></div>
    `;
  }
}

customElements.define('game-status-lit', GameStatusLit);

declare global {
  interface HTMLElementTagNameMap {
    'game-status-lit': GameStatusLit;
  }
}
